import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export type SupportTeam = {
    name: string | null;
    displayName: string | null;
    logo: string | null;
}

type SupportTeamsApiReturn = {
    isSuccess: boolean;
    data: {
        aflTeams: SupportTeam[] | null;
        bblTeams: SupportTeam[] | null;
    };
    errorMessages: string | null;
    exception: string | null;
}

const useSupportTeamsQuery = (): UseQueryResult<SupportTeamsApiReturn> => {
    const endpoint = '/api/Members/supportteams';

    const supportTeamsQuery = useQuery<SupportTeamsApiReturn>({
        queryKey: ['supportTeamsQuery'],
        queryFn: async() => {
            const response = await fetch(endpoint);
            if (!response.ok) {
                throw new Error(`Failed to fetch support teams: ${response.status} ${response.statusText}`);
            }
            return response.json();
        },
        staleTime: Number.POSITIVE_INFINITY,
    });

    return supportTeamsQuery;
};

export default useSupportTeamsQuery;
